/* Breakz — the Twitch player and chat, behind consent.
   ==================================================================

   Shared by the live page and the home page. Neither the player URL nor
   the chat URL exists in the markup: both are built here after a press,
   and only once marketing consent exists. Before that no request reaches
   Twitch, which is what ekomlov §3-15 requires. A refusal leaves the
   facade exactly where it was, and the page keeps working.

   The wording of the consent request comes from the section, because the
   person is asked at the moment they press, and the question has to name
   what they pressed.

   Markup this file reads:

     [data-lv-stage]      the 16:9 facade — data-channel, data-parent,
                          data-consent-ask; or data-video instead of
                          data-channel for a past broadcast on a break's
                          own page (the numeric Twitch video id)
     [data-lv-play]       the button inside it; a .lv-play-title inside
                          names the iframe
     [data-lv-chat]       a chat panel — the same three attributes and a
                          [data-lv-chat-body] that the iframe replaces
     [data-lv-chat-open]  the chat panel's own button
     [data-lv-root]       the live board — data-lv-chat-with-play="true"
                          loads its chat together with the stream

   One press on play also loads the chat where the board asks for it. Both
   are Twitch under the same marketing consent, so the one answer covers
   both; asking twice for the same thing would be noise. The home page has
   no chat panel, so there a press starts the player alone.
*/

(() => {
  if (window.__breakzLivePlayer) return;
  window.__breakzLivePlayer = true;

  const gated = (host, run) => {
    const consent = window.BreakzConsent;
    if (consent && !consent.allows('marketing')) {
      consent.request('marketing', host.dataset.consentAsk || null).then((ok) => { if (ok) run(); });
      return;
    }
    run();
  };

  const loadChat = (panel) => {
    if (panel.dataset.loaded) return;
    const channel = panel.dataset.channel;
    const parent = panel.dataset.parent;
    if (!channel || !parent) return;
    const frame = document.createElement('iframe');
    frame.src = `https://www.twitch.tv/embed/${encodeURIComponent(channel)}/chat?parent=${encodeURIComponent(parent)}&darkpopout`;
    frame.className = 'lv-chat-frame';
    frame.title = panel.querySelector('.lv-panel-head')?.textContent?.trim() || 'Live chat';
    panel.dataset.loaded = 'true';
    panel.querySelector('[data-lv-chat-body]')?.replaceWith(frame);
  };

  const startPlayer = (stage, play) => {
    const channel = stage.dataset.channel;
    const video = stage.dataset.video;
    const parent = stage.dataset.parent;
    if ((!channel && !video) || !parent) return;
    const source = video ? `video=v${encodeURIComponent(video)}` : `channel=${encodeURIComponent(channel)}`;
    const frame = document.createElement('iframe');
    frame.src = `https://player.twitch.tv/?${source}&parent=${encodeURIComponent(parent)}&autoplay=true`;
    frame.allow = 'autoplay; fullscreen; picture-in-picture';
    frame.allowFullscreen = true;
    frame.title = play.querySelector('.lv-play-title')?.textContent?.trim() || 'Live';
    stage.dataset.loaded = 'true';
    stage.append(frame);
    play.remove();
    stage.querySelector('.lv-elsewhere')?.remove();

    const board = stage.closest('[data-lv-root]');
    if (board && board.dataset.lvChatWithPlay === 'true') {
      const panel = board.querySelector('[data-lv-chat]');
      if (panel) loadChat(panel);
    }
  };

  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-lv-play]');
    if (play) {
      const stage = play.closest('[data-lv-stage]');
      if (!stage || stage.dataset.loaded) return;
      gated(stage, () => startPlayer(stage, play));
      return;
    }

    const open = event.target.closest('[data-lv-chat-open]');
    if (open) {
      const panel = open.closest('[data-lv-chat]');
      if (panel) gated(panel, () => loadChat(panel));
    }
  });
})();
